import { AnimatePresence } from "framer-motion"
import { Outlet } from "react-router-dom"

export const Portal = () => {

    return (
        <AnimatePresence mode="wait" initial={true} presenceAffectsLayout={false}>
            <Outlet />
        </AnimatePresence>

    )

}